import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IApiSageItemResponse } from '../../modules/graphql/types/types';

@Component({
  selector: 'app-sage-item-select-kendo',
  templateUrl: './sage-item-select-kendo.component.html',
  styleUrls: ['./sage-item-select-kendo.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SageItemSelectKendoComponent),
      multi: true
    }
  ]
})
export class SageItemSelectKendoComponent implements ControlValueAccessor {

  @Input() label = 'Sage Item';
  @Input() placeholder = 'Select Sage Item';
  @Input() required = false;
  @Input() sageList: IApiSageItemResponse[] = [];

  public selectedId: number | null = null;

  constructor() { }

  public onValueChange(value: number | null): void {
    this.selectedId = value;
    this._propagateChange(this.selectedId);
    this._onTouched();
  }

  private _propagateChange = (_: any) => { };
  private _onTouched = () => { };

  public writeValue(value: any): void {
    this.selectedId = value ?? null;
  }

  public registerOnChange(fn: any): void {
    this._propagateChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  public setDisabledState?(isDisabled: boolean): void { }
}
